// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2080":"37f4b26c","4252":"37f4b26c","4290":"37f4b26c","4310":"37f4b26c","9191":"37f4b26c"}[chunkId] + ".chunk.css";
};